
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'

export default class FormError extends React.Component {
  static propTypes = {
    text: PropTypes.string
  }

  render() {
    const {text} = this.props
    if (!text) return null
    return <div className='form-error'>{text}</div>
  }
}



// WEBPACK FOOTER //
// ./client/components/FormError/index.js